// extracted by mini-css-extract-plugin
module.exports = {"imagePreivewWrapper":"FileUpload_imagePreivewWrapper__2uBf5","hidden":"FileUpload_hidden__22Mfy","full":"FileUpload_full__3LWRK"};